<template>
  <div class="explore" :class="{ 'is-layout-animating': isLayoutAnimating }">
    <div v-if="showRenderTimer" class="render-status" role="status" aria-live="polite">
      <div class="sk-chase">
        <div class="sk-chase-dot"></div>
        <div class="sk-chase-dot"></div>
        <div class="sk-chase-dot"></div>
        <div class="sk-chase-dot"></div>
        <div class="sk-chase-dot"></div>
        <div class="sk-chase-dot"></div>
      </div>
      <div class="render-status__label">
        {{ isLoading ? "Loading explore data" : "Rendering explore page" }}
      </div>
      <div class="render-status__timer">
        {{ formattedRenderTime }} ({{ renderProgress }}%)
      </div>
    </div>

    <div v-if="!isLoading" ref="exploreContent">
      <div class="menu">
        <li><a :class="selectedView == 'ethols' ? 'black' : '-'" href="javascript:void(0);" @click="selectedView='ethols'">Ethols</a></li>
        <li><a :class="selectedView == 'holders' ? 'black' : '-'" href="javascript:void(0);" @click="selectedView='holders'">Holders</a></li>
      </div>
      
      <div v-show="selectedView == 'ethols'">
        <input v-model="enteredId" placeholder="etholvant #" min="0" />
        <input v-model="minCellsFilter" placeholder="min # of cells" />
        <input v-model="maxCellsFilter" placeholder="max # of cells" />
        <div class="etholCont">
          <div
            v-for="tokenId in visibleTokenIds"
            :key="tokenId"
            class="cont-inline"
            :data-token-id="tokenId"
          >
            <div
              class="ethol"
              @click="selectEthol(tokenId)"
              :class="{ selected: selectedId == tokenId }"
            >
              <img
                class="crown"
                v-if="tokenId == tokenIds[0]"
                src="../assets/crown.png"
              />
              <div v-show="animatedHist.tokenId != tokenId">
                <canvas
                  v-show="imgSources[tokenId]"
                  :ref="'etholCanvas' + tokenId"
                ></canvas>
                <div v-if="!imgSources[tokenId]" class="ethol-img-placeholder"></div>
                <div class="caption">
                  #{{ tokenId }} - {{ etholdata.etholvants[tokenId][1] }} cells
                  <br />
                  {{ etholdata.etholvants[tokenId][3] }} cells / 4hr
                </div>
              </div>
              <div v-show="animatedHist.tokenId == tokenId">
                <canvas :ref="'animatedCanvas' + tokenId"></canvas>
                <div class="caption">
                  #{{ tokenId }} - {{ animatedHist.numCells }} cells
                </div>
              </div>
              <div v-if="selectedId == tokenId" class="selected-actions" @click.stop>
                <br />
                <div class="option">
                  <a @click.stop="downloadScaled(tokenId)" href="javascript:void(0);">Download</a>
                </div>
                <div class="option">
                  <a
                    :href="
                      'https://opensea.io/assets/0x1fff1e9e963f07ac4486503e5a35e71f4e9fb9fd/' +
                      tokenId
                    "
                    target="_blank"
                    >View on OpenSea</a
                  >
                </div>
                <div class="option">
                  <a
                    @click.stop="animateHistory(tokenId)"
                    href="javascript:void(0);"
                    >See Evolution</a
                  >
                </div>
                <div class="option">
                  <a
                    :href="viewer3DHref(tokenId)"
                    target="_blank"
                    rel="noopener"
                    >View 3D</a
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="explore-footer" data-reflow-footer>
          <div class="buttonsCont">
            <button @click="firstPage">First</button>
            <button @click="prevPage">&#8249;</button>
            <button @click="nextPage">&#8250;</button>
            <button @click="lastPage">Last</button>
          </div>
          <div v-show="etholdata.timestamp" class="caption">
            Updated
            {{ Math.floor((Date.now() / 1000 - etholdata.timestamp) / 60) }} minutes
            ago.
          </div>
          <div class="pageNum">
            Page {{ index / pageSize + 1 }} of
            {{ Math.floor(this.sortedIds.length / this.pageSize) + 1 }} -
            {{ this.sortedIds.length }} results
          </div>
          <br />
        </div>
      </div>
      <div class="holdersDiv" v-if="selectedView == 'holders'">
        <p>
          <a style="font-size: 14px;" @click.stop="showTableInfo = !showTableInfo" href="javascript:void(0);"
            >Table Info</a
          >
        </p>
        <div class="table-info" v-show="showTableInfo">
          <p>Ethols: Total etholvant count.</p>
          <p>Cells: Total cell count.</p>
          <p>Growth: Total growth rate / 4hr if all staked.</p>
          <p>Click on any header to sort by that column.</p>
          <p>Click on any address to copy it.</p>
        </div>
        <table>
          <tbody>
            <tr>
              <td>#</td>
              <td>Address</td>
              <td :class="{selectedSort: tableSortBy == 'etholCount', clickable: true}" @click="tableSortBy='etholCount'">Ethols</td>
              <td :class="{selectedSort: tableSortBy == 'cellCount', clickable: true}" @click="tableSortBy='cellCount'">Cells</td>
              <td :class="{selectedSort: tableSortBy == 'growthRate', clickable: true}" @click="tableSortBy='growthRate'">Growth</td>
            </tr>
            <tr v-for="(holder, index) in holders" :key="holder">
              <td>{{ index + 1 }}</td>
              <td class="clickable" @click="copyText(holder)">{{ holder.substring(0, 10) }}</td> 
              <td>{{ holdersData.etholCount[holder] }}</td>
              <td>{{ holdersData.cellCount[holder] }}</td>  
              <td>{{ holdersData.growthRate[holder] }}</td>  
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import {
  drawCanvas,
  drawToCanvasAsync,
  disposeDrawWorkers,
  addOffsets,
  drawOffsetsToCanvas,
} from "../drawer";
import { fetchEtholData } from "../etholData";

export default {
  name: "Explore",
  props: {},
  components: {},
  data() {
    return {
      etholdata: {},
      isLoading: false,
      isRenderingPage: false,
      renderStartedAt: null,
      renderElapsedMs: 0,
      renderProgress: 0,
      renderTimer: null,
      renderFrame: null,
      renderCycle: 0,
      layoutAnimationTimer: null,
      pageRenderResumeTimer: null,
      pendingRenderAfterLayoutAnimation: false,
      isLayoutAnimating: false,
      sortedIds: [],
      tokenIds: [],
      imgSources: {},
      renderedCanvases: {},
      renderedCanvasOrder: [],
      renderedCanvasLimit: 120,
      index: null,
      pageSize: 12,
      enteredId: "",
      selectedId: null,
      minCells: null,
      maxCells: null,
      minCellsFilter: null,
      maxCellsFilter: null,
      selectedView: "ethols",
      holdersData: null,
      holders: null,
      showTableInfo: false,
      tableSortBy: "cellCount",
      animatedHist: {
        tokenId: null,
        numCells: null,
      },
    };
  },

  mounted() {
    this.fetchData();
  },

  beforeUnmount() {
    this.stopRenderTimer();
    if (this.layoutAnimationTimer) {
      clearTimeout(this.layoutAnimationTimer);
      this.layoutAnimationTimer = null;
    }
    if (this.pageRenderResumeTimer) {
      clearTimeout(this.pageRenderResumeTimer);
      this.pageRenderResumeTimer = null;
    }
    disposeDrawWorkers();
  },

  computed: {
    formattedRenderTime() {
      return (this.renderElapsedMs / 1000).toFixed(1) + "s";
    },

    showRenderTimer() {
      return this.isLoading || this.isRenderingPage;
    },

    visibleTokenIds() {
      return this.sortedIds.slice(this.index, this.index + this.pageSize);
    },
  },

  watch: {
    enteredId: function () {
      this.applyFilters();
    },

    minCellsFilter: function () {
      this.applyFilters();
    },

    maxCellsFilter: function () {
      this.applyFilters();
    },

    tableSortBy: function () {
      this.sortTable();
    },

    selectedView: function () {
      if (this.selectedView == "ethols") {
        this.startPageRender();
      }
    },
  },

  methods: {
    startRenderTimer() {
      this.stopRenderTimer();
      this.renderCycle += 1;
      this.renderStartedAt = Date.now();
      this.renderElapsedMs = 0;
      this.renderProgress = 0;
      this.renderTimer = setInterval(() => {
        this.renderElapsedMs = Date.now() - this.renderStartedAt;
      }, 100);
    },

    stopRenderTimer() {
      if (this.renderTimer) {
        clearInterval(this.renderTimer);
        this.renderTimer = null;
      }
      if (this.renderFrame) {
        cancelAnimationFrame(this.renderFrame);
        this.renderFrame = null;
      }
    },

    startPageRender() {
      this.startRenderTimer();
      this.isRenderingPage = true;
      this.finishInitialRender();
    },

    async generateImg(tokenId, onProgress, cycle) {
      await this.$nextTick();
      if (cycle != this.renderCycle) {
        return;
      }

      var canvas = this.getEtholCanvas(tokenId);
      if (!canvas) {
        return;
      }

      if (this.hasRenderedImage(tokenId, canvas)) {
        return;
      }

      if (this.copyCachedImage(tokenId, canvas)) {
        this.imgSources[tokenId] = true;
        if (onProgress) {
          onProgress(1, 1);
        }
        return;
      }

      var renderedCanvas = document.createElement("canvas");
      var drawnCanvas = await drawToCanvasAsync(
        this.etholdata.etholvants[tokenId][0],
        this.etholdata.etholvants[tokenId][1],
        this.etholdata.etholvants[tokenId][2],
        renderedCanvas,
        onProgress,
        () => cycle != this.renderCycle
      );
      if (!drawnCanvas || cycle != this.renderCycle) {
        return;
      }

      this.cacheRenderedImage(tokenId, renderedCanvas);
      this.copyCachedImage(tokenId, canvas);
      this.imgSources[tokenId] = true;
    },

    hasRenderedImage(tokenId, canvas) {
      var source = this.etholdata.etholvants[tokenId];
      if (!source) {
        return false;
      }

      var target = canvas || this.getEtholCanvas(tokenId);
      return (
        this.imgSources[tokenId] &&
        target &&
        target.width == source[2] &&
        target.height == source[2]
      );
    },

    copyCachedImage(tokenId, canvas) {
      var cachedCanvas = this.renderedCanvases[tokenId];
      if (!cachedCanvas || !canvas) {
        return false;
      }

      canvas.width = cachedCanvas.width;
      canvas.height = cachedCanvas.height;
      var ctx = canvas.getContext("2d");
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.drawImage(cachedCanvas, 0, 0);
      this.touchRenderedImage(tokenId);
      return true;
    },

    cacheRenderedImage(tokenId, canvas) {
      this.renderedCanvases[tokenId] = canvas;
      this.touchRenderedImage(tokenId);

      while (this.renderedCanvasOrder.length > this.renderedCanvasLimit) {
        var evictedTokenId = this.renderedCanvasOrder.shift();
        if (evictedTokenId != tokenId) {
          delete this.renderedCanvases[evictedTokenId];
          delete this.imgSources[evictedTokenId];
        }
      }
    },

    touchRenderedImage(tokenId) {
      var index = this.renderedCanvasOrder.indexOf(tokenId);
      if (index !== -1) {
        this.renderedCanvasOrder.splice(index, 1);
      }
      this.renderedCanvasOrder.push(tokenId);
    },

    getEtholCanvas(tokenId) {
      var ref = this.$refs["etholCanvas" + tokenId];
      return Array.isArray(ref) ? ref[0] : ref;
    },

    getAnimatedCanvas(tokenId) {
      var ref = this.$refs["animatedCanvas" + tokenId];
      return Array.isArray(ref) ? ref[0] : ref;
    },

    async renderVisibleImages(cycle) {
      var ids = this.visibleTokenIds.filter(
        (tokenId) => !this.hasRenderedImage(tokenId)
      );
      const total = ids.length || 1;

      for (var i = 0; i < ids.length; i++) {
        if (cycle != this.renderCycle) return;

        await this.waitForPaint();
        if (cycle != this.renderCycle) return;

        await this.generateImg(ids[i], (done, count) => {
          if (cycle != this.renderCycle) {
            return;
          }
          const imageProgress = count ? done / count : 1;
          this.renderProgress = Math.min(
            99,
            Math.floor(((i + imageProgress) / total) * 100)
          );
        }, cycle);
        if (cycle != this.renderCycle) return;

        this.renderElapsedMs = Date.now() - this.renderStartedAt;
        await this.$nextTick();
      }

      if (!ids.length) {
        this.renderProgress = 100;
      }
    },

    waitForImage(img) {
      if (img.complete) {
        if (img.decode) {
          return img.decode().catch(() => {});
        }
        return Promise.resolve();
      }

      return new Promise((resolve) => {
        var finish = () => {
          img.removeEventListener("load", finish);
          img.removeEventListener("error", finish);
          if (img.decode) {
            img.decode().catch(() => {}).finally(resolve);
            return;
          }
          resolve();
        };

        img.addEventListener("load", finish, { once: true });
        img.addEventListener("error", finish, { once: true });
      });
    },

    waitForRenderedImages() {
      var content = this.$refs.exploreContent;
      if (!content) {
        return Promise.resolve();
      }

      var images = Array.from(content.querySelectorAll("img"));
      return Promise.all(images.map(this.waitForImage)).then(() => {});
    },

    waitForPaint() {
      return new Promise((resolve) => {
        this.renderFrame = requestAnimationFrame(() => {
          this.renderFrame = requestAnimationFrame(() => {
            this.renderFrame = null;
            resolve();
          });
        });
      });
    },

    async finishInitialRender() {
      var cycle = this.renderCycle;

      await this.$nextTick();
      if (cycle != this.renderCycle) return;

      await this.renderVisibleImages(cycle);
      if (cycle != this.renderCycle) return;

      await this.waitForRenderedImages();
      if (cycle != this.renderCycle) return;

      await this.waitForPaint();
      if (cycle != this.renderCycle) return;

      await this.waitForPaint();
      if (cycle != this.renderCycle) {
        return;
      }

      this.renderElapsedMs = Date.now() - this.renderStartedAt;
      this.renderProgress = 100;
      this.isRenderingPage = false;
      this.stopRenderTimer();
    },

    fetchData() {
      this.startRenderTimer();
      this.isLoading = true;
      fetchEtholData()
        .then((data) => {
          this.etholdata = data;
          var ids = Object.keys(data["etholvants"]);
          ids.sort((a, b) =>
            data["etholvants"][a][1] < data["etholvants"][b][1] ? 1 : -1
          );
          this.tokenIds = ids;
          this.maxCells = this.etholdata["etholvants"][this.tokenIds[0]][1];
          this.minCells =
            this.etholdata["etholvants"][this.tokenIds.slice(-1)][1];
          // this.sortedIds = ids;
          this.applyFilters();
          this.index = 0;
          this.populateHolders();
        })
        .finally(() => {
          this.isRenderingPage = true;
          this.isLoading = false;
          this.finishInitialRender();
        });
    },

    populateHolders() {
      var data = this.etholdata['etholvants'];
      var etholCount = {};
      var cellCount = {};
      var growthRate = {};
      var holders = []
      Object.values(data).forEach(val => {
        var holder = val[4];
        etholCount[holder] = (etholCount[holder] || 0) + 1;
        cellCount[holder] = (cellCount[holder] || 0) + val[1];
        growthRate[holder] = (growthRate[holder] || 0) + val[3];
      });
      Object.keys(etholCount).forEach(holder => {
        if (holder != 'null') {
          holders.push(holder)
        }
      });
      this.holdersData = {
        etholCount: etholCount,
        cellCount: cellCount,
        growthRate: growthRate,
      }
      this.holders = holders;
      this.sortTable();
    },

    sortTable() {
      var sortBy;
      if (this.tableSortBy == 'cellCount') {
        sortBy = this.holdersData.cellCount;
      }
      else if (this.tableSortBy == 'etholCount') {
        sortBy = this.holdersData.etholCount;
      }
      else if (this.tableSortBy == 'growthRate') {
        sortBy = this.holdersData.growthRate;
      }
      this.holders.sort((a, b) =>
        sortBy[a] < sortBy[b] ? 1 : -1
      );
    },

    copyText(text) {
      navigator.clipboard.writeText(text);
      this.$notify({
        text: "Address coppied to clipboard.",
        type: "success",
      });
    },

    renderPageIfReady() {
      if (!this.isLoading && this.etholdata.etholvants) {
        this.startPageRender();
      }
    },

    applyFilters() {
      var ids = this.tokenIds;

      var vm = this;

      // burned
      function notBurned(element) {
        return vm.etholdata["etholvants"][element][4] != null;
      }
      if (this.etholdata.etholvants[0].length > 4) {
        ids = ids.filter(notBurned);
      }

      // entered id
      var enteredId = this.enteredId.trim();
      if (
        enteredId >= this.tokenIds.length ||
        isNaN(enteredId) ||
        enteredId < 0
      ) {
        this.sortedIds = [];
        this.renderPageIfReady();
        return;
      }
      if (enteredId != "") {
        enteredId = parseInt(enteredId);
        ids = [enteredId];
      }

      // min cells
      var minCellsFil = 0;
      if (this.minCellsFilter) {
        minCellsFil = this.minCellsFilter.trim();
      }
      if (isNaN(minCellsFil)) {
        this.sortedIds = [];
        this.renderPageIfReady();
        return;
      }
      minCellsFil = parseInt(minCellsFil);
      function isGreater(element) {
        return vm.etholdata["etholvants"][element][1] >= minCellsFil;
      }

      ids = ids.filter(isGreater);

      // max cells
      var maxCellsFil = this.maxCells;
      if (this.maxCellsFilter) {
        maxCellsFil = this.maxCellsFilter.trim();
      }
      if (isNaN(maxCellsFil)) {
        this.sortedIds = [];
        this.renderPageIfReady();
        return;
      }
      maxCellsFil = parseInt(maxCellsFil);
      function isLess(element) {
        return vm.etholdata["etholvants"][element][1] <= maxCellsFil;
      }

      ids = ids.filter(isLess);

      this.sortedIds = ids;
      this.index = 0;
      this.renderPageIfReady();
    },

    nextPage() {
      if (this.index + this.pageSize < this.sortedIds.length) {
        this.index += this.pageSize;
        this.startPageRender();
      }
    },

    prevPage() {
      if (this.index < this.pageSize) {
        this.index = 0;
        this.startPageRender();
        return;
      }
      this.index -= this.pageSize;
      this.startPageRender();
    },

    firstPage() {
      this.index = 0;
      this.startPageRender();
    },

    viewer3DHref(tokenId) {
      var route = this.$router.resolve({
        name: "viewer3d",
        params: { tokenId: tokenId },
      });
      return route.href;
    },

    lastPage() {
      this.index =
        Math.floor(this.sortedIds.length / this.pageSize) * this.pageSize;
      this.startPageRender();
    },

    selectEthol(tokenId) {
      var scrollPosition = this.captureScrollPosition();
      var positionsBefore = this.getCardPositions();
      this.clearCardReflowAnimation();
      this.pausePageRenderForCardAnimation();

      if (this.selectedId == tokenId) {
        this.selectedId = null;
        this.animateCardReflow(positionsBefore, scrollPosition);
        return;
      }
      this._resetAnimated();
      this.selectedId = tokenId;
      this.animateCardReflow(positionsBefore, scrollPosition);
    },

    captureScrollPosition() {
      return {
        x: window.pageXOffset || document.documentElement.scrollLeft || 0,
        y: window.pageYOffset || document.documentElement.scrollTop || 0,
      };
    },

    restoreScrollPosition(scrollPosition) {
      if (!scrollPosition) {
        return;
      }

      window.scrollTo(scrollPosition.x, scrollPosition.y);
    },

    pausePageRenderForCardAnimation() {
      if (!this.isRenderingPage) {
        return;
      }

      this.renderCycle += 1;
      this.pendingRenderAfterLayoutAnimation = true;
      disposeDrawWorkers();

      if (this.renderTimer) {
        clearInterval(this.renderTimer);
        this.renderTimer = null;
      }

      if (this.renderFrame) {
        cancelAnimationFrame(this.renderFrame);
        this.renderFrame = null;
      }

      if (this.pageRenderResumeTimer) {
        clearTimeout(this.pageRenderResumeTimer);
      }

      this.pageRenderResumeTimer = setTimeout(() => {
        this.pageRenderResumeTimer = null;
        if (!this.pendingRenderAfterLayoutAnimation) {
          return;
        }

        this.pendingRenderAfterLayoutAnimation = false;
        this.renderPageIfReady();
      }, 650);
    },

    getCardPositions() {
      var content = this.$refs.exploreContent;
      var positions = {};
      if (!content) {
        return positions;
      }

      content.querySelectorAll(".cont-inline[data-token-id]").forEach((el) => {
        var crown = el.querySelector(".crown");
        var media = this.getCardMediaElement(el);
        positions[el.dataset.tokenId] = {
          card: el.getBoundingClientRect(),
          crown: crown ? crown.getBoundingClientRect() : null,
          media: media ? media.getBoundingClientRect() : null,
        };
      });

      var footer = content.querySelector("[data-reflow-footer]");
      if (footer) {
        positions.__footer = footer.getBoundingClientRect();
      }

      return positions;
    },

    clearCardReflowAnimation() {
      if (this.layoutAnimationTimer) {
        clearTimeout(this.layoutAnimationTimer);
        this.layoutAnimationTimer = null;
      }
      this.isLayoutAnimating = false;

      var content = this.$refs.exploreContent;
      if (!content) {
        return;
      }

      content
        .querySelectorAll(".cont-inline[data-token-id], [data-reflow-footer]")
        .forEach((el) => {
          el.style.transition = "";
          el.style.transform = "";
          el.style.transformOrigin = "";
          el.style.willChange = "";
          var crown = el.querySelector(".crown");
          if (crown) {
            crown.style.transition = "";
            crown.style.transform = "";
            crown.style.transformOrigin = "";
            crown.style.willChange = "";
          }
          var media = this.getCardMediaElement(el);
          if (media) {
            media.style.transition = "";
            media.style.transform = "";
            media.style.transformOrigin = "";
            media.style.willChange = "";
          }
        });
    },

    getCardMediaElement(cardSlot) {
      return Array.from(
        cardSlot.querySelectorAll("canvas, .ethol-img-placeholder")
      ).find((el) => el.getClientRects().length);
    },

    animateCardReflow(positionsBefore, scrollPosition) {
      this.isLayoutAnimating = true;
      this.$nextTick(() => {
        this.restoreScrollPosition(scrollPosition);

        var content = this.$refs.exploreContent;
        if (!content) {
          this.isLayoutAnimating = false;
          return;
        }

        if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
          this.isLayoutAnimating = false;
          return;
        }

        var moved = [];
        content.querySelectorAll(".cont-inline[data-token-id]").forEach((el) => {
          var beforeState = positionsBefore[el.dataset.tokenId];
          var before = beforeState ? beforeState.card : null;
          if (!before) {
            return;
          }

          var after = el.getBoundingClientRect();
          var crown = el.querySelector(".crown");
          var media = this.getCardMediaElement(el);
          var crownAfter = crown ? crown.getBoundingClientRect() : null;
          var mediaAfter = media ? media.getBoundingClientRect() : null;
          var dx = before.left - after.left;
          var dy = before.top - after.top;
          var scaleX = after.width ? before.width / after.width : 1;
          var scaleY = after.height ? before.height / after.height : 1;
          var movedEnough = Math.abs(dx) >= 1 || Math.abs(dy) >= 1;
          var scaledEnough =
            Math.abs(scaleX - 1) >= 0.01 || Math.abs(scaleY - 1) >= 0.01;

          if (!movedEnough && !scaledEnough) {
            return;
          }

          el.style.transition = "none";
          el.style.transformOrigin = "top left";
          el.style.willChange = "transform";

          if (crown && beforeState.crown && crownAfter) {
            var crownScaleX = crownAfter.width
              ? beforeState.crown.width / (scaleX * crownAfter.width)
              : 1;
            var crownScaleY = crownAfter.height
              ? beforeState.crown.height / (scaleY * crownAfter.height)
              : 1;
            var crownDx =
              (beforeState.crown.left - after.left - dx) / scaleX -
              (crownAfter.left - after.left);
            var crownDy =
              (beforeState.crown.top - after.top - dy) / scaleY -
              (crownAfter.top - after.top);

            crown.style.transition = "none";
            crown.style.transformOrigin = "top left";
            crown.style.willChange = "transform";
            crown.style.transform =
              "translate(" +
              crownDx +
              "px, " +
              crownDy +
              "px) scale(" +
              crownScaleX +
              ", " +
              crownScaleY +
              ")";
          }

          if (media && beforeState.media && mediaAfter) {
            var mediaScaleX = mediaAfter.width
              ? beforeState.media.width / (scaleX * mediaAfter.width)
              : 1;
            var mediaScaleY = mediaAfter.height
              ? beforeState.media.height / (scaleY * mediaAfter.height)
              : 1;
            var mediaDx =
              (beforeState.media.left - after.left - dx) / scaleX -
              (mediaAfter.left - after.left);
            var mediaDy =
              (beforeState.media.top - after.top - dy) / scaleY -
              (mediaAfter.top - after.top);

            media.style.transition = "none";
            media.style.transformOrigin = "top left";
            media.style.willChange = "transform";
            media.style.transform =
              "translate(" +
              mediaDx +
              "px, " +
              mediaDy +
              "px) scale(" +
              mediaScaleX +
              ", " +
              mediaScaleY +
              ")";
          }

          el.style.transform =
            "translate(" +
            dx +
            "px, " +
            dy +
            "px) scale(" +
            scaleX +
            ", " +
            scaleY +
            ")";

          moved.push(el);
        });

        var footer = content.querySelector("[data-reflow-footer]");
        if (footer && positionsBefore.__footer) {
          var footerAfter = footer.getBoundingClientRect();
          var footerDx = positionsBefore.__footer.left - footerAfter.left;
          var footerDy = positionsBefore.__footer.top - footerAfter.top;

          if (Math.abs(footerDx) >= 1 || Math.abs(footerDy) >= 1) {
            footer.style.transition = "none";
            footer.style.transformOrigin = "top left";
            footer.style.willChange = "transform";
            footer.style.transform =
              "translate(" + footerDx + "px, " + footerDy + "px)";
            moved.push(footer);
          }
        }

        if (!moved.length) {
          this.isLayoutAnimating = false;
          return;
        }

        requestAnimationFrame(() => {
          this.restoreScrollPosition(scrollPosition);

          moved.forEach((el) => {
            el.style.transition =
              "transform 420ms cubic-bezier(0.22, 1, 0.36, 1)";
            el.style.transform = "translate(0, 0) scale(1, 1)";

            var crown = el.querySelector(".crown");
            if (crown) {
              crown.style.transition =
                "transform 420ms cubic-bezier(0.22, 1, 0.36, 1)";
              crown.style.transform = "translate(0, 0) scale(1, 1)";
            }

            var media = this.getCardMediaElement(el);
            if (media) {
              media.style.transition =
                "transform 420ms cubic-bezier(0.22, 1, 0.36, 1)";
              media.style.transform = "translate(0, 0) scale(1, 1)";
            }
          });

          this.layoutAnimationTimer = setTimeout(() => {
            moved.forEach((el) => {
              el.style.transition = "";
              el.style.transform = "";
              el.style.transformOrigin = "";
              el.style.willChange = "";
              var crown = el.querySelector(".crown");
              if (crown) {
                crown.style.transition = "";
                crown.style.transform = "";
                crown.style.transformOrigin = "";
                crown.style.willChange = "";
              }
              var media = this.getCardMediaElement(el);
              if (media) {
                media.style.transition = "";
                media.style.transform = "";
                media.style.transformOrigin = "";
                media.style.willChange = "";
              }
            });
            this.isLayoutAnimating = false;
            this.layoutAnimationTimer = null;
          }, 500);
        });
      });
    },

    getScaled(tokenId) {
      const sourceCanvas = drawCanvas(
        this.etholdata.etholvants[tokenId][0],
        this.etholdata.etholvants[tokenId][1],
        this.etholdata.etholvants[tokenId][2]
      );
      var size = 1000;
      var canvas2 = document.createElement("canvas");
      canvas2.width = size;
      canvas2.height = size;
      var ctx2 = canvas2.getContext("2d");
      ctx2.fillStyle = "#FFF";
      ctx2.fillRect(0, 0, size, size);
      ctx2.imageSmoothingEnabled = false;
      ctx2.drawImage(sourceCanvas, 0, 0, size, size);
      return canvas2.toDataURL("image/jpeg");
    },

    downloadScaled(tokenId) {
      var link = document.createElement("a");
      link.href = this.getScaled(tokenId);
      link.download = tokenId;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },

    _resetAnimated() {
      this.animatedHist = {
        tokenId: null,
        numCells: null,
      };
    },

    _updateHist(tokenId, offsets, max) {
      if (tokenId != this.animatedHist.tokenId) {
        return;
      }
      var currCells = offsets.length * 2 + 2;
      if (currCells == max || this.selectedId != tokenId) {
        this._resetAnimated();
        return;
      }

      var seed = this.etholdata.etholvants[tokenId][0];

      var stepSize = Math.max(Math.floor(currCells * 0.01), 1);
      if (currCells + stepSize * 2 > max) {
        stepSize = (max - currCells) / 2;
      }
      offsets = addOffsets(seed, offsets, stepSize);
      this.animatedHist.numCells = offsets.length * 2 + 2;
      this.$nextTick(() => {
        if (tokenId != this.animatedHist.tokenId) {
          return;
        }
        var canvas = this.getAnimatedCanvas(tokenId);
        if (canvas) {
          drawOffsetsToCanvas(offsets, canvas);
        }
        setTimeout(() => {
          this._updateHist(tokenId, offsets, max);
        }, 100);
      });
    },

    animateHistory(tokenId) {
      if (!tokenId) return;
      if (tokenId == this.animatedHist.tokenId) return;
      this.animatedHist.tokenId = tokenId;
      this.selectedId = tokenId;
      var seed = this.etholdata.etholvants[tokenId][0];
      var numCells = this.etholdata.etholvants[tokenId][1];
      var offsets = addOffsets(seed, [], 11);
      this._updateHist(tokenId, offsets, numCells);
    },
  },
};
</script>

<style scoped>
.explore {
  overflow-anchor: none;
}

.render-status {
  margin: 40px auto;
  text-align: center;
  font-size: 14px;
  color: #333;
}

.render-status .sk-chase {
  margin-top: 0;
  margin-bottom: 40px;
}

.render-status__timer {
  margin-top: 6px;
  font-family: monospace;
  color: #666;
}

.ethol img:not(.crown),
.ethol canvas {
  display: block;
  width: 100px;
  height: 100px;
  margin: auto;
  image-rendering: pixelated;
}

.ethol-img-placeholder {
  width: 100px;
  height: 100px;
  margin: auto;
  background:
    linear-gradient(90deg, #efefef 25%, #f8f8f8 50%, #efefef 75%);
  background-size: 200% 100%;
  animation: image-placeholder 1.2s infinite linear;
}

.ethol {
  --small-ethol-card-width: 190px;
  --selected-ethol-size: min(40vw, 40vh);
  display: inline-block;
  box-sizing: border-box;
  width: var(--small-ethol-card-width);
  font-size: 14px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  padding: 20px;
  vertical-align: top;
  transition:
    background-color 240ms ease,
    box-shadow 240ms ease;
}

.cont-inline {
  display: block;
  position: relative;
  vertical-align: top;
  transform-origin: top left;
  backface-visibility: hidden;
  overflow-anchor: none;
}

.ethol:hover {
  background-color: #e2e1e1;
  cursor: pointer;
}

.is-layout-animating .ethol-img-placeholder,
.is-layout-animating .sk-chase,
.is-layout-animating .sk-chase-dot {
  animation-play-state: paused;
}

.is-layout-animating .ethol {
  transition: none;
}

.selected {
  background-color: #f0f0f0;
  position: relative;
  width: calc(var(--selected-ethol-size) + 42px);
  box-shadow: 0 12px 34px rgba(0, 0, 0, 0.12);
}

.selected img:not(.crown),
.selected canvas {
  width: var(--selected-ethol-size);
  height: var(--selected-ethol-size);
}

.selected .ethol-img-placeholder {
  width: var(--selected-ethol-size);
  height: var(--selected-ethol-size);
}

.caption {
  font-size: 14px;
  margin: 5px;
  margin-top: 10px;
  margin-bottom: -5px;
}

button {
  margin-left: 5px;
  margin-right: 5px;
}

.buttonsCont {
  margin-top: 20px;
  margin-bottom: 20px;
}

.explore-footer {
  transform-origin: top left;
  backface-visibility: hidden;
}

.etholCont {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: center;
  gap: 40px;
  margin-top: 50px;
  margin-bottom: 40px;
  overflow-anchor: none;
}

.pageNum {
  text-align: center;
  font-size: 14px;
  margin-top: 20px;
}

input {
  padding: 8px;
  margin: 10px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 10px;
}

input:focus {
  border: 1px solid rgba(0, 0, 0, 0.473);
  outline: none;
  transition: all 0.4s;
}

.option {
  margin-top: 5px;
}

.crown {
  position: absolute !important;
  margin-left: -25px !important;
  margin-top: -60px !important;
  width: 50px !important;
  height: 50px !important;
}

.menu {
  margin-bottom: 40px;
}

.black {
  color: black;
}

.holdersDiv {
  overflow: scroll;
  margin: auto;
}

table tr:first-child {
    background: #efefef;
}

table {
  text-align: center;
}

.selectedSort {
    background: #e4e4e4;
}

.table-info {
  font-size: 14px;
  /* text-align: left; */
  margin: auto;
}

.clickable {
  cursor: pointer;
}

@keyframes image-placeholder {
  100% {
    background-position: -200% 0;
  }
}
</style>
